import styled from 'styled-components'

export const StyledSelectOptions = styled.div<{
  $maxHeight?: string
}>`
  ${({ theme, $maxHeight }) => `
    position: relative;
    overflow-y: auto;
    max-height: ${$maxHeight || '20rem'};
    flex: 1;
    min-height: 0;
    transition: 0.2s all;
  `}
`
